export enum POPUP_CONSTANTS {
  GUEST_TITLE = 'Dear Guest',
  GUEST_ADD_CART = 'To add to cart please login or sign up for an account',
  DOCTOR_LIMITED_TITLE = 'Attention',
  DOCTOR_LIMITED_DESCRIPTION = 'If you want to skip this step, you will have limited access to the app',
  DOCTOR_LIMITED_LEASE_TITLE = 'Attention',
  DOCTOR_LIMITED_LEASE_DESCRIPTION = 'You must submit account details before you can create your first booking.',
}
